// Singleton para controlar o chat externamente
let chatControlRef = null;

export const setChatControlRef = (ref) => {
  chatControlRef = ref;
};

export const openChat = () => {
  if (chatControlRef) {
    chatControlRef.openChat();
  }
};
